// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// import Sortable from "@stimulus-components/sortable"
import Sortable from "./sortable_controller.js"
application.register("sortable", Sortable)
 
import AddRowController from "./add_row_controller.js"
application.register("add-row", AddRowController)

import ExportTableController from "./export_table_controller.js"
application.register("export-table", ExportTableController)

import AutosubmitController from "./autosubmit_controller.js"
application.register("autosubmit", AutosubmitController)

import SelectController from "./select_controller.js"
application.register("select", SelectController)

import CompanySelectController from "./company_select_controller.js"
application.register("company-select", CompanySelectController)

import CurrencyController from "./currency_controller.js"
application.register("currency", CurrencyController)

import CurrencyRateController from "./currency_rate_controller.js"
application.register("currency-rate", CurrencyRateController)

import DatesController from "./dates_controller.js"
application.register("dates", DatesController)

import FlatpickrController from "./flatpickr_controller.js"
application.register("flatpickr", FlatpickrController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import UploadController from "./upload_controller.js"
application.register("upload", UploadController)

import MultiplyController from "./multiply_controller.js"
application.register("multiply", MultiplyController)

import SumController from "./sum_controller.js"
application.register("sum", SumController)

import ValidateTotalController from "./validate_total_controller.js"
application.register("validate-total", ValidateTotalController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import PaymentController from "./payment_controller.js"
application.register("payment", PaymentController)

import RemoteModalController from "turbo_remote_modal/app/javascript/controllers/remote_modal_controller.js"
application.register("remote-modal", RemoteModalController)

import TooltipController from "./tooltip_controller.js"
application.register("tooltip", TooltipController)

import ExpandableController from "./expandable_controller.js"
application.register("expandable", ExpandableController)

import QuickDestinationController from "./quick_destination_controller.js"
application.register("quick-destination", QuickDestinationController)

import ChartController from "./chart_controller.js"
application.register("chart", ChartController)

import PrintController from "./print_controller.js"
application.register("print", PrintController)

import ToastController from "./toast_controller.js"
application.register("toast", ToastController)

import TableController from "custom_table/app/javascript/controllers/table_controller.js"
application.register("table", TableController)

import AutocompleteController from "turbo_autocomplete/app/javascript/controllers/autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)
